export default __webpack_public_path__ + "static/media/pig.1d776feb.svg";